// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reset-box[data-v-2a27c8fb]{height:calc(100% - 20px);display:flex;align-items:center;justify-content:center}.reset__title[data-v-2a27c8fb]{line-height:1;color:#000;margin-bottom:16px}.reset__text[data-v-2a27c8fb],.reset__title[data-v-2a27c8fb]{text-align:center}", ""]);
// Exports
module.exports = exports;
